
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreateFreelancersListRequest,
  FreelancersList,
  FreelancersListsResponse,
} from '../models';
import {
    CreateFreelancersListRequestFromJSON,
    CreateFreelancersListRequestToJSON,
    FreelancersListFromJSON,
    FreelancersListToJSON,
    FreelancersListsResponseFromJSON,
    FreelancersListsResponseToJSON,
} from '../models';

export interface AddProfileToFavoriteListRequest {
    listId: string;
    profileId: string;
}

export interface CreateListRequest {
    createFreelancersListRequest: CreateFreelancersListRequest;
}

export interface GetListsRequest {
    q?: string;
    afterListId?: string;
}

export interface RemoveProfileFromFavoriteListRequest {
    listId: string;
    profileId: string;
}

/**
 * 
 */
export class PoolOfFreelancersApi extends runtime.BaseAPI {

    /**
     * Add a profile to a favorite list
          */
    async addProfileToFavoriteListRaw(requestParameters: AddProfileToFavoriteListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['listId'] == null) {
            throw new runtime.RequiredError(
                'listId',
                'Required parameter "listId" was null or undefined when calling addProfileToFavoriteList().'
            );
        }

        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling addProfileToFavoriteList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/pool-of-freelancers/lists/{listId}/profiles/{profileId}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters['listId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Add a profile to a favorite list
          */
    async addProfileToFavoriteList(requestParameters: AddProfileToFavoriteListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.addProfileToFavoriteListRaw(requestParameters, initOverrides);
    }

    /**
     * Create a list of favorites
          */
    async createListRaw(requestParameters: CreateListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancersList>> {
        if (requestParameters['createFreelancersListRequest'] == null) {
            throw new runtime.RequiredError(
                'createFreelancersListRequest',
                'Required parameter "createFreelancersListRequest" was null or undefined when calling createList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<FreelancersList>({
            path: `/search/api/pool-of-freelancers/lists`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateFreelancersListRequestToJSON(requestParameters['createFreelancersListRequest']),
        }, initOverrides);

        if (response._data) { response._data=FreelancersListFromJSON(response._data); }
        return response;
    }

    /**
     * Create a list of favorites
          */
    async createList(requestParameters: CreateListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancersList> {
        const response = await this.createListRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get favorite lists for current user
          */
    async getListsRaw(requestParameters: GetListsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancersListsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['afterListId'] != null) {
            queryParameters['afterListId'] = requestParameters['afterListId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancersListsResponse>({
            path: `/search/api/pool-of-freelancers/lists`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancersListsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get favorite lists for current user
          */
    async getLists(requestParameters: GetListsRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancersListsResponse> {
        const response = await this.getListsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Remove a profile from a favorite list
          */
    async removeProfileFromFavoriteListRaw(requestParameters: RemoveProfileFromFavoriteListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['listId'] == null) {
            throw new runtime.RequiredError(
                'listId',
                'Required parameter "listId" was null or undefined when calling removeProfileFromFavoriteList().'
            );
        }

        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling removeProfileFromFavoriteList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/api/pool-of-freelancers/lists/{listId}/profiles/{profileId}`.replace(`{${"listId"}}`, encodeURIComponent(String(requestParameters['listId']))).replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Remove a profile from a favorite list
          */
    async removeProfileFromFavoriteList(requestParameters: RemoveProfileFromFavoriteListRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.removeProfileFromFavoriteListRaw(requestParameters, initOverrides);
    }

}
